import {AbstractModel} from '../abstract-model';
import {LandingPage} from './landing-page';
import {Offer} from '../offer';

export class PoolLandingPage extends AbstractModel {
  id: number | null = null;
  landingPage: LandingPage | null = null;
  offer: Offer | null = null;
  offerId: number | null = null;
  weight: number | null = null;
  enabled: boolean = true;
  parameters: any = {};
  position: number = 0;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.landingPage) {
      this.landingPage = new LandingPage().deserialize(input.landingPage);
    }

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    return this;
  }

}
